import React from "react";
import "./Weather.css";
import "./App.css";
function App() {
  return (
    <div className="App">
      <footer>
        This project was coded by Yuliia Demchenko{" "}
        <a
          href="https://github.com/Yuceno4ek/react-weather-app"
          target="_blank"
          rel="noreferrer"
        >
          Open source code
        </a>
      </footer>
    </div>
  );
}

export default App;
